import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=4d1501bc&scoped=true&"
import script from "./LoginForm.vue?vue&type=script&lang=ts&"
export * from "./LoginForm.vue?vue&type=script&lang=ts&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=4d1501bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1501bc",
  null
  
)

component.options.__file = "LoginForm.vue"
export default component.exports